import request from "@/utils/request";

function SatisfactionGetTouristEvaluationNum(data) {   // 游客评价数据量
    return request({
        url: 'Satisfaction/getTouristEvaluationNum',
        method: 'POST',
        data
    })
}

function SatisfactionGetOtaSource(data) {      // 主要OTA来源
    return request({
        url: 'Satisfaction/getOtaSource',
        method: 'POST',
        data
    })
}

function SatisfactionGetTouristScoreRank(data) {   // 游客评分排名
    return request({
        url: 'Satisfaction/getTouristScoreRank',
        method: 'POST',
        data
    })
}

function SatisfactionGetSatisfactionAnalyse(data) {  // 满意度总体分析
    return request({
        url: 'Satisfaction/getSatisfactionAnalyse',
        method: 'POST',
        data
    })
}

function SatisfactionGetTourismEmotionRate(data) {  // 游客情绪占比图
    return request({
        url: 'Satisfaction/getTourismEmotionRate',
        method: 'POST',
        data
    })
}

function SatisfactionGetLatestOtaOptions(data) {  // 最新数据
    return request({
        url: 'Satisfaction/getLatestOtaOptions',
        method: 'POST',
        data
    })
}

export {
    SatisfactionGetTouristEvaluationNum,
    SatisfactionGetOtaSource,
    SatisfactionGetTouristScoreRank,
    SatisfactionGetSatisfactionAnalyse,
    SatisfactionGetTourismEmotionRate,
    SatisfactionGetLatestOtaOptions
}
